import { FullStoryAPI } from '@zapier/react-fullstory';

export const emitFullStoryEvent = (
  properties: { interaction_name: string } & Record<string, any>
) => {
  FullStoryAPI('event', properties.interaction_name, properties);
};
